/* eslint-disable no-lone-blocks */
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import {toast} from 'react-toastify'
import {ENV} from '../../../Utils/_helpers/EnvHelper'
const initialState = {
  userDetails: {},
}
const API_URL = ENV().REACT_APP_API_URL

export const fetchAsyncAdminDetails: any = createAsyncThunk(
  'userDetails/fetchAsyncAdminDetails',
  async () => {
    const response = await axios.get(`${API_URL}user/me`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
    return response.data
  }
)
export const uploadProfileImage: any = createAsyncThunk(
  'userDetails/uploadProfileImage',
  async (data: any) => {
    const response = await axios.post(`${API_URL}fileStroage/uploadFile`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
    return response.data
  }
)

const AdminProfile = createSlice({
  name: 'userDetails',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAsyncAdminDetails.pending]: (state) => {},
    [fetchAsyncAdminDetails.fulfilled]: (state, {payload}) => {
      {
        payload.status === false && toast.error(payload.message)
      }
      return {...state, userDetails: payload}
    },
    [fetchAsyncAdminDetails.rejected]: () => {},
  },
})

export const getAllAdminDetails = (state: any) => state.userDetails.userDetails.data?.user
export default AdminProfile.reducer
